import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { Select2Data } from 'ng-select2-component';
import { RenaultOnlinePaymentDashboard } from '../models/renault-online-payment';

@Injectable({
  providedIn: 'root'
})

export class OnlinePaymentService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultOnlinePayment/";

  constructor(private http: HttpClient) { }

  public LoadOnlinePayments(file: File): Observable<any> {
    let formData: FormData = new FormData();
    if (file != undefined) {
      formData.append('fileOnlinePayments', file, file.name);
    }
    return this.http.post<any>(this.pathAPI + this.controller + 'LoadOnlinePayments', formData);
  }

  public getDataTable(data: any, filter): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + filter, data);
  }

  public getDataTableLog(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableLog/', data);
  }

  public getStatus(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetStatus');
  }

  public getTaxNumber(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetTaxNumber');
  }

  public getAccountNumber(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetAccountNumber');
  }

  public getDashboard(filter): Observable<RenaultOnlinePaymentDashboard> {
    return this.http.get<RenaultOnlinePaymentDashboard>(this.pathAPI + this.controller + 'GetDashboard/' + filter);
  }

  downloadExcel(): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetFileExcel';
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }
}
